import { Link } from "react-router-dom";
import type { Blog } from "../lib/api";
import PipelineProgress from "../ui/PipelineProgress";

export default function BlogCard({ blog }: { blog: Blog }) {
  const flaggedCount =
    blog.review_flags?.filter((f) => f.severity === "error").length ?? 0;
  const suggestionCount =
    blog.review_flags?.filter((f) => f.severity === "warn").length ?? 0;

  return (
    <Link
      to={`/blog/${blog.id}`}
      className={[
        "group block rounded-xl border border-ink-100 bg-white p-5",
        "hover:border-brand-300 hover:shadow-md hover:shadow-ink-900/5 hover:-translate-y-0.5",
        "transition-[border-color,box-shadow,transform] duration-150",
      ].join(" ")}
    >
      <div className="flex items-start justify-between gap-4 mb-3">
        <div className="min-w-0 flex-1">
          <h3 className="font-display text-lg font-semibold text-ink-800 truncate group-hover:text-brand-700 transition-colors">
            {blog.title ?? blog.chosen_topic ?? "(pending title)"}
          </h3>
          {(blog.chosen_topic || blog.user_topic_hint) && (
            <p className="text-sm text-ink-500 mt-0.5 truncate">
              {blog.chosen_topic ?? blog.user_topic_hint}
            </p>
          )}
          <div className="flex items-center gap-3 mt-2 text-xs text-ink-500">
            <span>{new Date(blog.created_at).toLocaleDateString()}</span>
            {blog.triggered_by === "weekly_cron" && (
              <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-ink-100 text-ink-600 font-medium">
                Auto
              </span>
            )}
            {flaggedCount > 0 && (
              <span className="inline-flex items-center gap-1.5 text-red-700 font-medium">
                <span className="h-1.5 w-1.5 rounded-full bg-red-500" />
                {flaggedCount} flagged
              </span>
            )}
            {suggestionCount > 0 && (
              <span className="inline-flex items-center gap-1.5 text-amber-700 font-medium">
                <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
                {suggestionCount} suggestion{suggestionCount !== 1 && "s"}
              </span>
            )}
          </div>
        </div>
      </div>

      <PipelineProgress
        kind="blog"
        status={blog.status}
        reviewPassed={blog.review_passed}
        variant="compact"
      />
    </Link>
  );
}
